import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export interface TeamMemberPayload {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  password: string;
  customers_status: string;
  customers_password1:string;
}

@Component({
  selector: 'molla-exclusive-team',
  templateUrl: './exclusive-team.component.html',
  styleUrls: ['./exclusive-team.component.scss']
})
export class ExclusiveTeamComponent implements OnInit, OnChanges {

  @Input() show = false;
  @Output() closed = new EventEmitter<void>();
  @Output() created = new EventEmitter<TeamMemberPayload>();

  teamForm!: FormGroup;
  submittedOnce = false;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.teamForm = this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show && changes.show.currentValue) {
      this.teamForm = this.buildForm();
      this.submittedOnce = false;
      this.showPassword = false;
      this.showConfirmPassword = false;
    }
  }

  private buildForm(): FormGroup {
    return this.fb.group(
      {
        firstname: ['', [Validators.required, Validators.minLength(2)]],
        lastname: ['', [Validators.required, Validators.minLength(1)]],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', [Validators.required, Validators.pattern(/^[0-9+\-\s()]{7,20}$/)]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirm_password: ['', [Validators.required]]
      },
      { validators: this.matchPasswords('password', 'confirm_password') }
    );
  }

  private matchPasswords(pwd: string, confirm: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const p = group.get(pwd)?.value;
      const c = group.get(confirm)?.value;
      return p && c && p !== c ? { passwordMismatch: true } : null;
    };
  }

  get f() {
    return this.teamForm.controls;
  }

  onClose(): void {
    this.closed.emit();
  }

  onSubmit(): void {
    this.submittedOnce = true;
    if (this.teamForm.invalid) {
      Object.keys(this.teamForm.controls).forEach(k => this.teamForm.controls[k].markAsTouched());
      return;
    }
    const { firstname, lastname, email, phone, password } = this.teamForm.value;
    this.created.emit({
      firstname, lastname, email, phone, password,
      customers_status: '',
      customers_password1: ''
    });
  }
}
